export default {
  actions: {
    copied: "Копирано в клипборда",
    copyFailed: "Неуспешно копиране",
    pdfDownloaded: "PDF файлът е изтеглен за визита #{visitId}",
    pdfDownloadFailed: "Неуспешно изтегляне на PDF",
    loadVisitResultsFailed: "Неуспешно зареждане на резултатите от визита",
    loadTestHistoryFailed: "Неуспешно зареждане на историята на изследването",
    loadVisitFlagsFailed: "Неуспешно зареждане на флаговете на визита",
    channelStarted: "{channelName} е стартиран успешно",
    channelStartFailed: "Неуспешно стартиране на {channelName}",
    channelStopped: "{channelName} е спрян успешно",
    channelStopFailed: "Неуспешно спиране на {channelName}",
    cacheCleared: "Сървърният кеш е изчистен успешно",
    cacheClearFailed: "Неуспешно изчистване на сървърния кеш",
    featureNotImplemented: "Тази функция все още не е налична",
    refreshFailed: "Неуспешно обновяване \u2014 показват се последните известни данни.",
  },

  tooltips: {
    copyBarcode: "Копиране на баркода в клипборда",
  },
};
